// ----------------------------------------------------------------------
// <copyright file="Izenda.ActivationActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

! function () {
  
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var AccountStore = require('logic/Izenda.AccountStore');  

  var activationActions = compose(
    withHandlers({
      initStore: initStore,      
      validateExpirationPasswordLink: validateExpirationPasswordLink
    }));

  /**
   * Initial store.
   */
  function initStore() {
    return function (component) {
      component.store = new AccountStore();
    };
  }

  /**
   * Validate expiration of password link.
   */
  function validateExpirationPasswordLink() {
    return function (component) {
      var props = component.props;
      var query = props.location.query;
      var verification = query.verification;
      var store = component.store;
      var loader = props.loader;

      loader.startLoading();
      return store.validateExpirationPasswordLink(verification).then(function (result) {
        store.updateInfoAfterCheckedPasswordLink(verification, result.success ? result.data.isExpired : null);
        return Promise.resolve(result.success);
      }).finally(loader.endLoading.bind(loader));
    };
  }

  module.exports = activationActions;
}();


// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.ActivationActions.js